import React from 'react'
import ImgBranch from "../../assets/images/about/branch-img.webp" 

function BranchTeam() {
    
  return (

    <>
        
        <section className='branch-and-team'>
            <div className='container'>
                <div className='top-head'>
                    <h2 className='ttl1'>Branches & Team Strength</h2>
                </div>
                <div className='branch-flex-list'>
                    <div className='branch-flx-itm'>
                        <div className='flx-cont'>
                            <h3>Mumbai</h3>
                            <h4><span>120+</span> Member across teams in</h4>
                            <ul>
                                <li>Product</li>
                                <li>Development</li>
                                <li>Data</li>
                                <li>Cyber security</li>
                                <li>DevOps</li>
                            </ul>
                        </div>
                        <div className='flx-img'>
                            <img src={ImgBranch} width={447} height={380} alt='' />
                        </div>
                    </div>
                    <div className='branch-flx-itm'>
                        <div className='flx-cont'>
                            <h3>Pune</h3>
                            <h4><span>80+</span> across teams in</h4>
                            <ul>
                                <li>R&D</li>
                                <li>Innovation</li>
                                <li>Quality Assurance</li>
                            </ul>
                        </div>
                        <div className='flx-img'>
                            <img src={ImgBranch} width={447} height={380} alt='' />
                        </div>
                    </div>
                </div>
            </div>
        </section>

        
    </>
  )
}

export default BranchTeam